import * as React from "react";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  TextInput,
  DateTimeInput,
  required,
  AutocompleteInput,
  SelectInput,
} from "react-admin";
import { CustomToolbar } from "../../shared/components/index.js";
import { PROMOTION_STATUSES } from "@local/constants/index.js";

const createPromotion = () => {
  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record.url}
        alt={record.name}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <Create redirect="show">
      <SimpleForm toolbar={<CustomToolbar />} mode="all">
        <TextInput
          multiline
          sx={{
            width: "30%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          rows={4}
          source="title"
          inputProps={{ maxLength: 255 }}
          validate={[required()]}
        />
        <ReferenceInput source="file_id" reference="File">
          <AutocompleteInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            inputText={(record) => record.name}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            validate={[required()]}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        <TextInput
          sx={{
            width: "30%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="text"
          multiline
          rows={4}
          fullWidth
          validate={[required()]}
          inputProps={{ maxLength: 255 }}
        />
        <DateTimeInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="start_date"
          defaultValue={new Date()}
          validate={[required()]}
        />
        <DateTimeInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="end_date"
          defaultValue={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}
          validate={[required()]}
        />
        <SelectInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          validate={[required()]}
          choices={Object.keys(PROMOTION_STATUSES).map((status) => ({
            id: status,
            name: `resources.Promotion.source.status.${status}`,
          }))}
        />
      </SimpleForm>
    </Create>
  );
};

export default createPromotion;
